import { route, tag, type PageTour } from '../pageTour';

export const accessControlTour: PageTour = {
  id: 'page-access-control',
  version: 1,
  title: 'Access Control',
  summary: 'Decide which users can see which cameras.',
  match: route('/access-control'),
  steps: [
    {
      target: tag('access-control-help'),
      title: 'How access works',
      description: 'A user sees the cameras in the groups you assign plus any cameras you assign directly — nothing else.',
      side: 'bottom',
    },
    {
      target: tag('access-control-users'),
      title: 'Choose a user',
      description: 'Search for and select the user whose camera access you want to change for this site.',
      side: 'right',
    },
    {
      target: tag('access-control-editor'),
      title: 'Assign groups and cameras',
      description: 'Tick the camera groups and individual cameras this user may see, then save your changes.',
      side: 'left',
    },
  ],
};
